'use client';

import { c as _c } from "react/compiler-runtime";
import { Check } from 'lucide-react';
import { Mode, ModeConfig } from '@/components/shared/types';
import { getDesc, getTech, getBorderBgColor } from '@/components/shared/helpers';
import { useTranslation } from '@/context/I18nContext';
import { getExperienceData } from '@/data/loader';
interface ExperienceSectionProps {
  activeMode: Mode;
  design: ModeConfig['design'];
  isDark: boolean;
}
export default function ExperienceSection(t0) {
  const $ = _c(49);
  const {
    activeMode,
    design
  } = t0;
  const {
    locale,
    t
  } = useTranslation();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== activeMode || $[1] !== design.accent || $[2] !== design.border || $[3] !== design.borderRadius || $[4] !== design.cardBg || $[5] !== design.cardBorder || $[6] !== design.fontFamily || $[7] !== design.shadow || $[8] !== design.textPrimary || $[9] !== design.textSecondary || $[10] !== locale || $[11] !== t) {
    const expData = getExperienceData(locale);
    t3 = "experience-section";
    t4 = "";
    const t6 = `mb-10 text-sm font-bold uppercase tracking-widest flex items-center gap-4 ${design.textSecondary}`;
    let t7;
    if ($[17] !== activeMode) {
      t7 = activeMode === "backend" && <span className="terminal-prompt" />;
      $[17] = activeMode;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== t) {
      t8 = t("common.professionalExperience");
      $[19] = t;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t9;
    if ($[21] !== activeMode) {
      t9 = getBorderBgColor(activeMode);
      $[21] = activeMode;
      $[22] = t9;
    } else {
      t9 = $[22];
    }
    const t10 = `h-px flex-1 ${t9} opacity-30`;
    let t11;
    if ($[23] !== t10) {
      t11 = <span className={t10} />;
      $[23] = t10;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    if ($[25] !== t11 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
      t5 = <h2 className={t6}>{t7}{t8}{t11}</h2>;
      $[25] = t11;
      $[26] = t6;
      $[27] = t7;
      $[28] = t8;
      $[29] = t5;
    } else {
      t5 = $[29];
    }
    t1 = "space-y-12";
    let t12;
    if ($[30] !== activeMode || $[31] !== design.accent || $[32] !== design.border || $[33] !== design.borderRadius || $[34] !== design.cardBg || $[35] !== design.cardBorder || $[36] !== design.fontFamily || $[37] !== design.shadow || $[38] !== design.textPrimary || $[39] !== design.textSecondary) {
      t12 = job => {
        const getHoverBorderClass = _temp;
        return <div key={job.id} id={`exp-${job.id}`} data-sublayer-id={`exp-${job.id}`} data-sublayer-name={job.role} className={`relative ${activeMode === "ai" ? "pl-12" : "pl-8"} border-l ${design.border} transition-all duration-300 hover:border-l-2 ${getHoverBorderClass(activeMode)} group z-10 ${activeMode === "ai" ? "py-2" : ""} ${activeMode === "qa" ? `border ${design.cardBorder} ${design.cardBg} ${design.shadow} rounded-lg p-4` : ""}`}><div className="mb-2"><h4 className={`text-xl font-bold ${design.textPrimary} ${activeMode === "blockchain" ? "green-glow" : ""}`}>{activeMode === "qa" && <Check className="inline h-4 w-4 mr-2 text-green-500" />}{activeMode === "backend" && <span className="terminal-prompt" />}{job.role}</h4></div><div className="flex items-center gap-3 mb-4"><div className={`text-base font-medium ${design.accent}`}>{job.company}</div><span className={`text-xs ${design.fontFamily === "mono" ? "font-mono" : ""} ${design.textSecondary} opacity-70`}>{job.period}</span></div><p className={`text-base leading-7 ${design.textSecondary}`}>{getDesc(job, activeMode)}</p><div className="mt-6 flex gap-2 flex-wrap">{getTech(job, activeMode).map(t_0 => <span key={t_0} className={`text-xs px-2 py-1 ${design.borderRadius} ${activeMode === "blockchain" ? "bg-[#003300] text-[#00FF41]" : activeMode === "backend" ? "bg-white/5 text-emerald-400" : activeMode === "mobile" ? "glass-effect border border-sky-400/30 text-sky-300" : activeMode === "frontend" ? "bg-rose-100 text-rose-700" : activeMode === "qa" ? "bg-white/40 backdrop-blur border border-cyan-200/60 text-cyan-800 shadow-sm shadow-cyan-100/50" : "bg-slate-100 text-slate-600"}`}>{activeMode === "qa" && <Check className="inline h-3 w-3 mr-1 text-green-500" />}{t_0}</span>)}</div></div>;
      };
      $[30] = activeMode;
      $[31] = design.accent;
      $[32] = design.border;
      $[33] = design.borderRadius;
      $[34] = design.cardBg;
      $[35] = design.cardBorder;
      $[36] = design.fontFamily;
      $[37] = design.shadow;
      $[38] = design.textPrimary;
      $[39] = design.textSecondary;
      $[40] = t12;
    } else {
      t12 = $[40];
    }
    t2 = expData.map(t12);
    $[0] = activeMode;
    $[1] = design.accent;
    $[2] = design.border;
    $[3] = design.borderRadius;
    $[4] = design.cardBg;
    $[5] = design.cardBorder;
    $[6] = design.fontFamily;
    $[7] = design.shadow;
    $[8] = design.textPrimary;
    $[9] = design.textSecondary;
    $[10] = locale;
    $[11] = t;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  let t6;
  if ($[41] !== t1 || $[42] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[41] = t1;
    $[42] = t2;
    $[43] = t6;
  } else {
    t6 = $[43];
  }
  let t7;
  if ($[44] !== t3 || $[45] !== t4 || $[46] !== t5 || $[47] !== t6) {
    t7 = <section data-section-id={t3} className={t4}>{t5}{t6}</section>;
    $[44] = t3;
    $[45] = t4;
    $[46] = t5;
    $[47] = t6;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  return t7;
}
function _temp(mode) {
  if (mode === "pm") {
    return "hover:border-indigo-600";
  }
  if (mode === "frontend") {
    return "hover:border-rose-600";
  }
  if (mode === "backend") {
    return "hover:border-emerald-500";
  }
  if (mode === "mobile") {
    return "hover:border-sky-500";
  }
  if (mode === "blockchain") {
    return "hover:border-[#FF6B00]";
  }
  if (mode === "qa") {
    return "hover:border-cyan-500";
  }
  if (mode === "ai") {
    return "hover:border-[#00F0FF]";
  }
  return "hover:border-indigo-600";
}